// Documentation.jsx

import React, { useRef, useEffect, useState } from "react";
import subscription from "../../assets/subscription.jpg";
import admindashboard from "../../assets/adminDashboard.jpg";
import clients from "../../assets/clients.jpg";
import addclients from "../../assets/add-clients.jpg";
import pscases from "../../assets/pscases.jpg";
import psintake from "../../assets/psintake.jpg";
import psform from "../../assets/psform.jpg";
import casedocsupload from "../../assets/casedocsupload.jpg";
import servees from "../../assets/servees.jpg";
import serviceattmpts from "../../assets/serviceattmpts.png";
import timeline from "../../assets/timeline.jpg";
import case_messaging from "../../assets/case_messaging.jpg";
import CaseActivity from "../../assets/CaseActivity.jpg";
import Affidavitgen from "../../assets/Affidavitgen.jpg";
import gpscheckin from "../../assets/gpscheckin.jpg";
import seviceform from "../../assets/seviceform.jpg";
import editcase from "../../assets/editcase.jpg";
import EditCaseForm from "../../assets/EditCaseForm.jpg";
import picaseform from "../../assets/picaseform.jpg";
import picaselist from "../../assets/picaselist.jpg";
import ViewPiCase from "../../assets/ViewPiCase.jpg";
import picaseagents from "../../assets/picaseagents.jpg";
import FieldWork from "../../assets/FieldWork.jpg";
import Picaseupdate from "../../assets/Picaseupdate.jpg";
import picaselogs from "../../assets/picaselogs.jpg";
import teams from "../../assets/teams.jpg";
import Teamsform from "../../assets/Teamsform.jpg";
import TimeAndEx from "../../assets/TimeAndEx.jpg";
import TimeAndExForm from "../../assets/TimeAndExForm.jpg";
import Invoices from "../../assets/Invoices.jpg";
import invoiceform from "../../assets/invoiceform.jpg";
import invoiceDetails from "../../assets/invoiceDetails.jpg";
import invoiceEdit from "../../assets/invoiceEdit.jpg";
import subs from "../../assets/subs.jpg";
import CaseDash from "../../assets/CaseDash.jpg";
import ServerDash from "../../assets/ServerDash.jpg";
import FDDASH from "../../assets/ServerDash.jpg";
import clientsdash from "../../assets/clientsdash.jpg";
import cinvoice from "../../assets/cinvoice.jpg";
import payinvoice from "../../assets/payinvoice.jpg";
import importClients from "../../assets/importClients.jpg";
import importClientsB from "../../assets/importClientsB.jpg";
import adminDashboardStripe from "../../assets/adminDashboardStripe.jpg";
import stripeOnboarding from "../../assets/stripeOnboarding.jpg";
import clientProcessList from "../../assets/clientProcessList.jpg";
import clientCaseIntake from "../../assets/clientCaseIntake.jpg";
import clientPiList from "../../assets/clientPiList.jpg";
import clientPiIntake from "../../assets/clientPiIntake.jpg";
import exportButton from "../../assets/exportbutton.jpg";
import exportScreen from "../../assets/exportscreen.jpg";
import exportScreen2 from "../../assets/exportscreen2.jpg";

// --- Dummy Placeholder Image ---

// --- Documentation Data ---
const documentationData = {
  onboarding: {
    title: "User Onboarding Process",
    image: subscription,
    description:
      "Users can choose a subscription plan on IntelServe and add a payment method to start their 14-day free trial. Your card will not be charged until the trial period ends. You can cancel anytime during the trial.",
    attachments: [
      // { name: "Welcome Guide.pdf", type: "pdf" },
      // { name: "Onboarding-Flow.png", type: "image" }
    ],
    submenus: [
      // { id: 'onboarding-step1', title: 'Step 1: Account Creation' },
      // { id: 'onboarding-step2', title: 'Step 2: Profile Configuration' },
      // { id: 'onboarding-step3', title: 'Step 3: Initial Data Sync' },
    ],
  },
  admin: {
    title: "Organization Admin Panel",
    image: admindashboard,
    description: `Admins gain access to a feature-rich dashboard that displays key insights about organization performance, ongoing cases, and a complete activity log. Here are some features:`,
    attachments: [],
    submenus: [
      {
        id: "Stripe-Setup",
        title: "Connect Stripe Payment",
        content:
          "Upon logging in, if you have not yet set up a payment method, you will see a 'Payments Setup' banner at the top of your Dashboard. Click the 'Connect Stripe' button to link your Stripe account. This is required to receive payments for invoices generated within IntelServe.",
        subContent:
          "You will be redirected to the Stripe onboarding page to complete the secure setup process.",
        image1: adminDashboardStripe,
        image2: stripeOnboarding,
      },
      {
        id: "Client-Management",
        title: "Client Management",
        content:
          "Any paid plan subscriber can create and update unlimited client records. Users with the Case Manager role can also create and edit clients. However, Field Managers and Process Servers cannot create, view, or update client personal information.",
        subContent:
          "A client profile can include multiple contact persons. You can designate a primary contact, and all associated contacts can be granted login access to the main client dashboard.",
        image1: clients,
        image2: addclients,
      },
      {
        id: "Import-Clients",
        title: "Import Clients",
        content:
          "You can bulk import clients quickly using a CSV file. Navigate to the Clients page and select the Import option to upload your CSV. This allows you to add multiple client records to your organization at once without manual entry.",
        image1: importClientsB,
        image2: importClients,
      },
      {
        id: "Export-Clients",
        title: "Export Clients",
        content:
          "You can bulk export clients quickly using a CSV file. Navigate to the Clients page and select the Export option to download your CSV. This allows you to retrieve multiple client records from your organization at once without manual entry.",
        subContent:" You can choose between exporting all clients in the default format or customizing the export by mapping database fields to your desired CSV column headers.",
         image1: exportButton,
        image2: exportScreen,
        image3: exportScreen2,
        
      },
      {
        id: "Process-Service-Case-Management",
        title: "Process Service Case Management",
        isMain: true,
        content:
          "The Process Server Cases list provides a comprehensive view of all ongoing and closed cases. You can easily filter the list by 'Status' or 'Service Type' to find specific records. The list displays key details including the Client, Assigned Team Members, and current Service Status. From the 'Actions' column, you can quickly View, Edit, or Delete a case.",
        image1: pscases,
        image2: psform,
      },
      {
        id: "PS-servee-docs",
        content:
          "Multiple servees can be added, and multiple files (both case-level and servee-level) can be uploaded while creating a case.",
        image1: servees,
        image2: casedocsupload,
      },
      {
        id: "PS-details",
        content:
          "The Case View / Details page displays all case information along with features such as GPS check-ins, recording service attempts, and managing each servee individually. These features are available to Admins, Case Managers, and Servers.",
        subContent:
          "To serve a servee, the Server (Admin / Case Manager / Server role) starts the Service process using the button provided on the Case Details page. After starting, they can add service attempts with notes and proof, mark the servee as Served, or mark the service as Failed. A corresponding affidavit is automatically generated for each servee once they are marked as Served or Failed.",
        image1: serviceattmpts,
        image2: timeline,
        image3: gpscheckin,
        image4: seviceform,
      },
      {
        id: "PS-affidavit",
        content:
          "The Case Intake PDF can be downloaded from the Case View / Details page. Affidavits for both Served and Not-Served will be generated once the Admin, Case Manager, or Server marks the Servee as Served/Not-Served and uploads the proof and signature.",
        subContent:
          "Once all servees in a case are marked as Served, the Admin or Case Manager can close the case by updating it. To edit or update a case—or to reassign one or more Servers—the Admin can open the case from the Case List by clicking “View Case.” On the Case Details page, an “Edit” button will be available to make the necessary updates or reassignments.",
        image1: psintake,
        image2: Affidavitgen,
        image3: editcase,
        image4: EditCaseForm,
      },
      {
        id: "PS-details-client",
        content:
          "Clients also have access to the case through their portal, where they can view case progress, activity logs, all recorded attempts, and download any uploaded files and affidavits.",
      },
      {
        id: "PS-activity",
        content:
          "The Case Messaging feature is available only on the Elite plan. It can be used to leave instructions or notes for the team, and clients can also send messages from their portal.",
        image1: case_messaging,
        image2: CaseActivity,
      },
      {
        id: "Private-Investigation-Case-Management",
        title: "Private Investigation Case Management",
        content:
          "Private Investigation cases can be accessed from the Cases menu. A new case can be created by clicking the “Add Case” button located at the top-right of the page. Existing cases can be viewed by clicking the “View” button from the case list. On the Case View page, the “Edit Case” button can be used to update or modify case details.",
        subContent:
          "Field Agents can be assigned to a PI case from the Case Edit page by the Admin or Case Manager.",
        image1: picaselist,
        image2: ViewPiCase,
        image3: picaseform,
        image4: picaseagents,
      },
      {
        id: "Private-Investigation-updates",
        content:
          "Field work for PI cases can be updated here by adding notes and uploading videos, audio files, and documents. Previous activity logs can also be viewed in this section. Case Messaging is also available to users on the Elite plan.",
        subContent:
          "This page can be accessed by the Admin and Case Manager with full privileges. Field Agents can add field updates, upload videos, and mark field work as completed. When any field work is marked as completed, a Surveillance Report is automatically generated.",
        image1: FieldWork,
        image2: Picaseupdate,
        image3: picaselogs,
      },
      {
        id: "PI-details-client",
        content:
          "Clients also have access to the pi case through their portal, where they can view case progress, activity logs, all Field Updates, and download any uploaded files and Surveillance Report.",
      },
      {
        id: "Teams",
        title: "Team Management",
        content:
          "This feature is available only to the Admin for managing the organization's team. The Admin can create new users with the roles of Admin, Case Manager, Field Agent, and Server. Each user will receive access to their own panel with the tools and permissions necessary for their role.",
        image1: teams,
        image2: Teamsform,
      },
      {
        id: "Time-Expenses",
        title: "Time & Expenses",
        content:
          "The Time & Expenses feature can be used by Admins, Case Managers, Field Agents, and Servers to record expenses while working on a case. Admins and Case Managers can also review and delete invalid expense entries, as well as create new ones.",
        image1: TimeAndEx,
        image2: TimeAndExForm,
      },
      {
        id: "Invoice-Management",
        title: "Invoice Management",
        content:
          "Invoices can be created by the Admin and Case Manager. On the creation page, you can link the invoice to a specific Client and Case, set the Issue and Due dates, and enter the Total Amount. If your Stripe account is not yet connected, a banner will appear allowing you to connect it immediately. You can also check the box to automatically email the invoice to the client upon creation.",
        image1: Invoices,
        image2: invoiceform,
      },
      {
        id: "Invoice-Actions",
        title: "Managing Invoices",
        content:
          "Once an invoice is created, you can view its full details and download a generic copy by clicking the 'Download PDF' button. If changes are needed, you can edit the invoice details (such as dates, amounts, or client info) and save your changes by clicking 'Update Invoice'.",
        image1: invoiceDetails,
        image2: invoiceEdit,
      },
      {
        id: "subs",
        title: "Subscription Management",
        content:
          "This is for Admin only. On this page, the Admin can cancel the subscription, reverse a cancellation, or resubscribe to the plan.",
        image1: subs,
      },
    ],
  },
  "case-manager": {
    title: "Case Manager Dashboard",
    image: CaseDash,
    description:
      "The Case Manager has all the same features as the Admin, except for Team Management and Subscripton.",
    attachments: [],
    submenus: [
      // { id: 'api-auth', title: 'Authentication Flow', content: "", image: null },
      // { id: 'api-endpoints', title: 'Key Endpoints Reference', content: "", image: null },
      // { id: 'api-webhooks', title: 'Webhook Configuration', content: "", image: null },
    ],
  },
  server: {
    title: "Server Dashboard",
    image: ServerDash,
    description:
      "Servers can view the Case Detail page by clicking on Cases and manage their assigned cases just like in the Admin Process Serve Case Management workflow. They can also log Time & Expenses, which can be reviewed and approved by the Admin or Case Manager. Tasks have now been moved to the Case Detail page. The Task List section here will be removed in a future update.",
    attachments: [],
    submenus: [
      // { id: 'api-auth', title: 'Authentication Flow', content: "", image: null },
      // { id: 'api-endpoints', title: 'Key Endpoints Reference', content: "", image: null },
      // { id: 'api-webhooks', title: 'Webhook Configuration', content: "", image: null },
    ],
  },
  fieldAgent: {
    title: "Field Agent Dashboard",
    image: FDDASH,
    description:
      "Field Agents have similar features to Servers. They can also view the PI Case Detail page and manage their assigned field tasks as described above in the Admin section. They can also create Time & Expense entries, which will be available for the Admin and Case Manager to review.",
    attachments: [],
    submenus: [
      // { id: 'api-auth', title: 'Authentication Flow', content: "", image: null },
      // { id: 'api-endpoints', title: 'Key Endpoints Reference', content: "", image: null },
      // { id: 'api-webhooks', title: 'Webhook Configuration', content: "", image: null },
    ],
  },
  client: {
    title: "Client Dashboard",
    image: clientsdash,
    description:
      "Upon logging in, clients are presented with a comprehensive Dashboard giving them a complete snapshot of their account. The 'My Cases' section lists all associated cases (both Process Serve and Private Investigation), displaying real-time Status, Due Dates, and Work Status. Below that, the 'My Invoices' section provides a quick summary of recent billing, allowing clients to track invoice amounts, due dates, and payment statuses (e.g., Paid) at a glance.",
    attachments: [],
    submenus: [
      {
        id: "Client-Invoices",
        title: "Client Invoices",
        content: "",
        image1: cinvoice,
        image2: payinvoice,
      },
      {
        id: "Client-Process-Cases",
        title: "Process Service Cases",
        content:
          "Clients can manage their Process Service cases directly from the portal. The 'Process Service' page lists all associated cases with their current status. Clients can also initiate a new service request by clicking the 'Create New Case' button.",
        subContent:
          "Clicking 'Create New Case' opens the Digital Process Service Intake form. Here, the client can fill in all necessary details—including their information, case specifics, servee details, and document uploads—to submit a new request immediately.",
        image1: clientProcessList,
        image2: clientCaseIntake,
      },
      {
        id: "Client-PI-Cases",
        title: "Private Investigation Cases",
        content:
          "Clients can also manage their Private Investigation cases. The 'Private Investigation' page displays a list of all current cases with details like Case Number, Field Work Status, and overall Status. Similar to Process Service, clients can request a new investigation by clicking the 'Create New Case' button.",
        subContent:
          "This opens the Private Investigation Intake form, where the client can provide specific investigation details (such as Case Type and Title) to initiate the request.",
        image1: clientPiList,
        image2: clientPiIntake,
      },
    ],
  },
};

const Documentation = () => {
  const sectionRefs = useRef({});
  const [activeId, setActiveId] = useState(Object.keys(documentationData)[0]);

  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (!entry.isIntersecting) return;

          const id = entry.target.id;
          const parentKey = documentationData[id]
            ? id
            : Object.keys(documentationData).find((key) =>
                documentationData[key].submenus?.some((sub) => sub.id === id)
              );
          if (parentKey) setActiveId(parentKey);
        });
      },
      { rootMargin: "0px 0px -70% 0px" }
    );

    Object.keys(documentationData).forEach((key) => {
      observer.observe(sectionRefs.current[key]);
      documentationData[key].submenus?.forEach((sub) =>
        observer.observe(sectionRefs.current[sub.id])
      );
    });

    return () => observer.disconnect();
  }, []);

  const handleMenuClick = (id) => {
    sectionRefs.current[id]?.scrollIntoView({
      behavior: "smooth",
      block: "start",
    });
  };

  return (
    <div className="min-h-screen bg-gray-50">
      <header className="sticky top-0 z-10 bg-white border-b shadow-sm p-4">
        <h1 className="text-xl font-bold">
          <span className="text-sky-600">IntelServe</span> Documentation
        </h1>
      </header>

      <div className="container mx-auto px-4 flex">
        {/* Sidebar */}
        <aside className="hidden lg:block w-1/4 py-10 pr-6">
          <nav className="sticky top-20 space-y-1">
            {Object.keys(documentationData).map((key) => {
              const menu = documentationData[key];
              const isActive = key === activeId;
              return (
                <div key={key}>
                  <button
                    onClick={() => handleMenuClick(key)}
                    className={`w-full text-left px-3 py-2 rounded-md text-sm font-medium transition
                      ${
                        isActive
                          ? "bg-sky-500 text-white shadow"
                          : "hover:bg-gray-200 text-gray-700"
                      }`}
                  >
                    {menu.title}
                  </button>

                  {isActive && menu.submenus && (
                    <ul className="ml-3 mt-1 border-l border-sky-200 pl-3 space-y-1">
                      {menu.submenus.map(
                        (sub) =>
                          sub.title && (
                            <li key={sub.id}>
                              <button
                                onClick={() => handleMenuClick(sub.id)}
                                className="text-xs text-gray-500 hover:text-sky-600"
                              >
                                {sub.title}
                              </button>
                            </li>
                          )
                      )}
                    </ul>
                  )}
                </div>
              );
            })}
          </nav>
        </aside>

        {/* Content */}
        <main className="w-full lg:w-3/4 py-10 space-y-12">
          {Object.keys(documentationData).map((key) => {
            const section = documentationData[key];
            return (
              <section
                key={key}
                id={key}
                ref={(el) => (sectionRefs.current[key] = el)}
                className="bg-white p-6 rounded-lg shadow border border-gray-100 scroll-mt-28"
              >
                <h2 className="text-2xl font-bold mb-4">{section.title}</h2>

                <img src={section.image} className="rounded-lg shadow mb-4" />

                <p classname="text-gray-600 leading-relaxed mb-6">
                  {section.description}
                </p>
                {section.attachments.length > 0 && (
                  <>
                    {/* Attachments */}
                    <div className="mb-6">
                      <h4 className="text-sm font-semibold text-gray-700 mb-2">
                        📎 Attachments
                      </h4>
                      <div className="flex gap-3 flex-wrap">
                        {section.attachments?.map((a, index) => (
                          <div
                            key={index}
                            className="px-3 py-2 text-xs bg-gray-100 rounded border border-gray-200 shadow-sm"
                          >
                            {a.name}
                          </div>
                        ))}
                      </div>
                    </div>
                  </>
                )}

                {section.submenus?.map((sub) => (
                  <div
                    key={sub.id}
                    id={sub.id}
                    ref={(el) => (sectionRefs.current[sub.id] = el)}
                    className="bg-white p-6  scroll-mt-28"
                  >
                    {sub.title && (
                      <h3
                        className={
                          sub.isMain
                            ? "text-lg font-bold border-l-4 border-blue-200  pl-4 mb-2"
                            : "text-lg font-semibold border-l-4 border-sky-200  pl-4 mb-2"
                        }
                      >
                        {sub.title}
                      </h3>
                    )}
                    {sub.content && (
                      <p className="text-gray-600 leading-relaxed mb-4">
                        {sub.content}
                      </p>
                    )}

                    <div className="flex flex-wrap gap-4 mt-4">
                      {sub.image1 && (
                        <img
                          src={sub.image1}
                          alt=""
                          className="
                            w-full
                            sm:w-[calc(50%-0.5rem)]   /* 2 per row on desktop */
                            rounded-lg shadow object-contain
                          "
                        />
                      )}

                      {sub.image2 && (
                        <img
                          src={sub.image2}
                          alt=""
                          className="
                            w-full
                            sm:w-[calc(50%-0.5rem)]   /* 2 per row on desktop */
                            rounded-lg shadow object-contain
                          "
                        />
                      )}
                    </div>

                    {sub.subContent && (
                      <p className="text-gray-800 leading-relaxed mb-4 mt-4">
                        {sub.subContent}
                      </p>
                    )}

                    <div className="flex flex-wrap gap-4 mt-4 mb-2">
                      {sub.image3 && (
                        <img
                          src={sub.image3}
                          alt=""
                          className="
                            w-full
                            sm:w-[calc(50%-0.5rem)]   /* 2 per row on desktop */
                            rounded-lg shadow object-contain
                          "
                        />
                      )}

                      {sub.image4 && (
                        <img
                          src={sub.image4}
                          alt=""
                          className="
                            w-full
                            sm:w-[calc(50%-0.5rem)]   /* 2 per row on desktop */
                            rounded-lg shadow object-contain
                          "
                        />
                      )}
                    </div>
                  </div>
                ))}
              </section>
            );
          })}
        </main>
      </div>
    </div>
  );
};

export default Documentation;
